import { DOCUMENT } from '@angular/common';
import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { UserService } from '@shared/services';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ThkeeCommonModule, ToastService, UiSnippetsComponent } from 'thkee-common';

@Component({
  selector: 'app-manage-user',
  imports: [
    RouterModule,
    AngularSvgIconModule,
    ReactiveFormsModule,
    ThkeeCommonModule,
    FormsModule,
    UiSnippetsComponent,
  ],
  templateUrl: './manage-user.component.html',
  styleUrl: './manage-user.component.scss',
})
export class ManageUserComponent implements OnInit {
  private userService = inject(UserService);
  private toastService = inject(ToastService);
  private router = inject(Router);
  private document = inject<Document>(DOCUMENT);
  private platformId = inject(PLATFORM_ID);

  loginForm!: FormGroup;
  isSubmitted: boolean = false;
  loginAsURL: string = '';
  public selectedRedirectOption: 'new_tab' | 'redirect' = 'new_tab';

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });

    const isCredential = sessionStorage.getItem('login_as_admin_url');
    if (isCredential) {
      this.loginAsURL = isCredential;
    }
  }

  loginAsForm() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    this.isSubmitted = true;
    this.userService.adminAsUserLogin({ user_email: this.loginForm.value.email }).subscribe({
      next: (res) => {
        this.isSubmitted = false;
        // const targetUrl = new URL(environment.authUrl);
        // targetUrl.searchParams.set('refresh', res.refresh);
        // targetUrl.searchParams.set('token', res.access);
        // if (isPlatformBrowser(this.platformId)) {
        //   window.open(targetUrl.toString(), '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        // }
        if (this.selectedRedirectOption === 'new_tab') {
          window.open(environment.authUrl, '_blank');
        } else if (this.selectedRedirectOption === 'redirect') {
          window.location.href = environment.authUrl;
        }
        // this.copyToClipboard(targetUrl.toString());
        this.loginForm.reset();

        // sessionStorage.setItem('login_as_admin_url', targetUrl.toString());
        // this.loginAsURL = targetUrl.toString();
      },
      error: (err) => {
        this.isSubmitted = false;
        this.toastService.error({
          message: 'Sign in failed! Please try again.',
        });
      },
    });
  }

  copyToClipboard(url: string) {
    navigator.clipboard.writeText(url).then(() => {
      this.toastService.message({
        message: 'URL copied to clipboard. Please open it in a private window.',
      });
    });
  }

  get email() {
    return this.loginForm.get('email');
  }
}
